var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineChartWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 50,
    rx: 5,
    fill: "#2a2a2a",
    stroke: "#444"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "10,40 25,20 40,30 55,15 70,25 85,10",
    stroke: "#36cbcb",
    fill: "none",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChartWidget);
export default __webpack_public_path__ + "static/media/line-chart-widget.9f38aa0ca27cde4a997879ae81ca5b26.svg";
export { ForwardRef as ReactComponent };